<template>
    <div
        class="relative w-full overflow-hidden"
        :class="{ 'cursor-pointer': url }"
        :style="skewStyle"
        :role="url ? 'link' : null"
        :tabindex="url ? 0 : null"
        data-testid="promo-card"
        @click="open"
        @keydown.enter="open"
    >
        <img
            :src="imageSrc"
            :alt="blok.background?.alt || ''"
            class="block h-auto w-full object-cover"
            loading="lazy"
        />

        <!-- Visual CTA only: the click bubbles up to the card, which opens the link. -->
        <div v-if="url" class="absolute inset-x-0 bottom-0 flex justify-end p-3">
            <DiagonalCutButton
                variant="primary"
                cut-position="left-top"
                padding="py-1 px-2"
                :full-width="false"
                tabindex="-1"
                data-testid="promo-card-cta"
            >
                {{ $t('home.promo_banner_cta') }}
            </DiagonalCutButton>
        </div>
    </div>
</template>

<script>
import DiagonalCutButton from '@/components/ui/DiagonalCutButton.vue'
import { storyblokImage } from '@/services/storyblok.js'
import { resolveShopUrl } from '@/services/shopLink.js'

// Storyblok block `game-on-promo-card`, nested in the `promo_cards` field of
// the `game-on-homepage-promotions` story:
//   background  Asset      — the card image (880x320 in the CMS)
//   link        Multilink  — shop URL the card opens (translatable, so each
//                            language can point at its own country shop)
// Cards without a valid Dartshopper https link render as a plain image.
export default {
    name: 'PromoCardBlock',
    components: { DiagonalCutButton },
    props: {
        blok: {
            type: Object,
            required: true,
        },
        // Rendered width in CSS pixels; requested at 2x for retina screens.
        width: {
            type: Number,
            default: 400,
        },
    },
    emits: ['promo-click'],
    computed: {
        imageSrc() {
            return storyblokImage(this.blok.background, { width: this.width * 2 })
        },
        url() {
            return resolveShopUrl(this.blok.url)
        },
        skewStyle() {
            return { clipPath: 'polygon(10px 0, 100% 0, 100% 100%, 0 100%, 0 10px)' }
        },
    },
    methods: {
        open() {
            if (this.url) this.$emit('promo-click', this.url)
        },
    },
}
</script>
